// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'
import toast from 'react-hot-toast'

export const getData = createAsyncThunk('requestManagement/getData', async params => {
  const response = await axios.get(`${process.env.REACT_APP_BASE_API}Schedule/requestManagement/requestManagementList`, {params})
  return {
    params,
    data: response.data.Response.items,
    totalPages: response.data.Response.total_items
  }
})

export const getRequestManagement = createAsyncThunk('requestManagement/getRequestManagement', async id => {
  let response = {}
  if (id > 0) {
    response = await axios.get(`${process.env.REACT_APP_BASE_API}Schedule/requestManagement/requestManagementEdit/${id}`)
    return response.data.Response
  } else {
    return response
  }
})

export const createRequestManagement = createAsyncThunk('request/addRequest', async (CreateRequest) => {
  const response = await axios.post(`${process.env.REACT_APP_BASE_API}Schedule/request/requestCreate`, {
    Request: {
      CreateRequest
    }
  })
  
  if (response.data.Response.Code === 1) {
    toast.success('Event success')
  } else {
    toast.error('Error')
  }
  return CreateRequest
})

export const updateRequestManagement = createAsyncThunk('requestManagement/addRequestManagement', async (UpdateRequestManagement) => {
  const response = await axios.put(`${process.env.REACT_APP_BASE_API}Schedule/requestManagement/requestManagementUpdate`, {
    Request: {
      UpdateRequestManagement
    }
  })

  if (response.data.Response.Code === 1) {
    toast.success('Event success')
  } else {
    toast.error(response.data.Response.Description, {
        duration: 15000
    })
  }
  return UpdateRequestManagement
})

export const updateRequestManagementItem = createAsyncThunk(
  'requestManagement/updateItem',
  async (UpdateItem) => {
    const response = await axios.put(
      `${process.env.REACT_APP_BASE_API}Schedule/requestManagement/requestManagementItemUpdate`, // confirmar nombre real con backend
      { Request: { UpdateItem } }
    )
    if (response.data.Response.Code === 1) toast.success('Ítem actualizado')
    else toast.error(response.data.Response.Description, { duration: 15000 })
    return UpdateItem
  }
)

export const rejectRequestManagement = createAsyncThunk('requestManagement/requestManagementReject', async (RejectRequestManagement) => {
  const response = await axios.patch(`${process.env.REACT_APP_BASE_API}Schedule/requestManagement/requestManagementReject`, {
    Request: {
      RejectRequestManagement
    }
  })

  if (response.data.Response.Code === 1) {
    toast.success('Event success')
  } else {
    toast.error('Error')
  }
  return RejectRequestManagement
})

export const getWarehouseAvailable = createAsyncThunk('requestManagement/getWarehouseAvailable', async (id, { rejectWithValue }) => {
  try {
    if (id > 0) {
      const response = await axios.get(`${process.env.REACT_APP_BASE_API}Schedule/requestManagement/requestManagementAvailablesWarehousesList/${id}`)
      if (response.data.Response.Code === 1) {
        return response.data.Response.Warehouses
      } else {
        return rejectWithValue(response.data.Response.Description)
      }
    } else {
      return []
    }
  } catch (error) {
    return rejectWithValue(error.message)
  }
})

export const appCategoriesSlice = createSlice({
  name: 'requestManagements',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedRequestManagement: [],
    selectedRequestManagementAvailablesWarehouses: [],
    loading: false,
    loadingWarehouses: false
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getData.pending, (state) => {
        state.loading = true
      })
      .addCase(getData.fulfilled, (state, action) => {
        state.loading = false
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getRequestManagement.pending, (state) => {
        state.loading = true
      })
      .addCase(getRequestManagement.fulfilled, (state, action) => {
        state.loading = false
        state.selectedRequestManagement = action.payload.data
      })
      .addCase(getWarehouseAvailable.pending, (state) => {
        state.loadingWarehouses = true
      })
      .addCase(getWarehouseAvailable.fulfilled, (state, action) => {
        state.loadingWarehouses = false
        state.selectedRequestManagementAvailablesWarehouses = action.payload
      })
      .addCase(getWarehouseAvailable.rejected, (state) => {
        state.loadingWarehouses = false
      })
  }
})

export default appCategoriesSlice.reducer
